import { t } from '@lingui/core/macro';
import { Box, Chip } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SidebarMenuBody } from 'app/domains/common-ui';
import { useCompanyFeatures } from 'app/domains/companies';
import { MetadataNotifications } from 'app/domains/metadata';
import { useFeatureFlag } from 'shared/domains/featureFlag';
import { CollapsibleCustomerSuccess } from './CollapsibleCustomerSuccess';
import { CollapsibleDocuments } from './CollapsibleDocuments';
import { CollapsibleInsights } from './CollapsibleInsights';
import { CollapsibleSavedViews } from './CollapsibleSavedViews';
import { CollapsibleSettings } from './CollapsibleSettings';
import { ItemLink } from './ItemLink';
import { UserGuidingButton } from './UserGuidingButton';
export function Body() {
    const showCustomerSuccess = useFeatureFlag('feature_customer_success');
    const { isFeatureAvailable } = useCompanyFeatures();
    const globalPlai = isFeatureAvailable('global-assistant:basic');
    const showProjects = isFeatureAvailable('projects');
    return (<SidebarMenuBody>
      {globalPlai && (<ItemLink to="/plai/chat" icon={<Falcon icon="sparkles"/>} adornmentRight={<Box pr="md">
              <Chip appearance="secondary" size="small" label="BETA"/>
            </Box>} label={t({
                comment: 'Sidebar menu - Global PLAI label',
                message: 'PLAI',
                context: 'sidebar',
            })} matchPath={['/plai']}/>)}
      <ItemLink matchExact to="/dashboard" icon={<Falcon icon="grid-2"/>} label={t({ comment: 'Sidebar menu - Dashboard label', message: 'Dashboard', context: 'sidebar' })} matchPath={['/dashboard', '/documents/*']}/>
      {showProjects && (<ItemLink to="/projects" icon={<Falcon icon="rectangle-history"/>} label={t({ comment: 'Sidebar menu - Projects label', message: 'Projects', context: 'sidebar' })} matchPath={['/projects', '/projects/:projectId']}/>)}
      <CollapsibleDocuments />
      <CollapsibleInsights />
      <CollapsibleSavedViews />
      <ItemLink to="/tasks" icon={<Falcon icon="list-check"/>} label={t({ comment: 'Sidebar menu - Tasks label', message: 'Tasks', context: 'sidebar' })} matchPath={['/tasks']}/>
      <ItemLink to="/contracts" icon={<Falcon icon="pen-to-square"/>} label={t({ comment: 'Sidebar menu - Templates label', message: 'Templates', context: 'sidebar' })} matchPath={['/contracts']}/>
      <CollapsibleSettings />
      {showCustomerSuccess && <CollapsibleCustomerSuccess />}
      <MetadataNotifications />
      <UserGuidingButton />
    </SidebarMenuBody>);
}
